import React, { useState } from "react";
import { Engines, ExploreIcon, FeaturesImage, ExploreSectionImg } from "../../assets";
import styles from './index.module.css';
import { useMotionValueEvent, useScroll } from "framer-motion";
import { EngineCard, Sparkels } from "../../Components";
import { Explore } from "..";

const Features = (props) => {

    const [scrollPos, setScrollPos] = useState(0);
    const { scrollY } = useScroll();

    useMotionValueEvent(scrollY, "change", (latest) => {
        latest < 400 && setScrollPos(latest);
      });
    
    return (
      <div >
      <div className={`${styles["hero-spacer"]}`} />
      <div
        key={scrollPos}
        className={`${styles["content-section"]}`}
      >
        <h3 className={`${styles.title}`}>
          Large Master's Database
        </h3>
        <Sparkels />
        <p className={`${styles.subp} pb-5`}>
          Explore millions of master games for free ! <span className="font-bold">More Than 5.4 Million Master Games</span> updated regularly.
          All master games are 2000+ ELO with fixed player and event names. 
          <br />
          In addition we offer a large database of analyzed chess positions so you can save time and get the best analysis for the most common positions right away !

        </p>
        <div className="flex items-center justify-center w-full">
        <div className={`${styles.imgContainer} flex items-center justify-center w-[85%] min-w-[350px] w-[36em] py-[3%]`}>
        <img src={ExploreSectionImg} className="rounded w-[95%] "/>
        </div>
        </div>
      </div>
      
        </div>
    )
}

export default Features;